// Electrical component types and states
export enum NodeCategory {
  Board = 'board',
  Capacitor = 'capacitor',
  Resistor = 'resistor',
  Inductor = 'inductor',
}

export enum NodeHoverState {
  Add = 'add',
  NotAdd = 'not-add',
}

// Minimum distance for proximity connections
export const MIN_DISTANCE = 75; // Reduced from 150

// Node types that support proximity connections
export const PROXIMITY_NODE_TYPES = [
    'event',
    'pipeline',
    'transformations',
    'filter',
    'schema-enforcement',
    'bot-filtering',
    'data-replay',
    // Strict connection nodes that also support proximity connections
    'cluster',
    'sync-injector',
    'load-balancer',
    'source',
    'javascript-source',
    'mobile-sdk',
    'server-source',
    'destination'
    // Group nodes no longer support proximity connections
];
